/* import __COLOCATED_TEMPLATE__ from './status-404.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class SiteErrorStatus404 extends Component {}
